import { Component, Inject, Input } from "@angular/core";

import { BasketItem } from "@hermes/api-model-basket";

import { Product } from "@hermes/api-model-product";
import { LOCALE } from "@hermes/app-core";
import { isChina, Locale } from "@hermes/locale";

@Component({
    selector: "h-shipping-delay-message",
    templateUrl: "./shipping-delay-message.component.html",
    styleUrls: ["./shipping-delay-message.component.scss"],
})
export class ShippingDelayMessageComponent {
    /** Current page product */
    @Input()
    public product!: Product | BasketItem;

    protected readonly isChina = isChina(this.locale);

    constructor(@Inject(LOCALE) private locale: Locale) {}
}
